import { Component, signal } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'app-full-screen-button',
  imports: [
    MatIconModule,
    MatButtonModule,
    MatTooltipModule,
    TranslatePipe,
  ],
  templateUrl: './full-screen-button.html',
  styleUrl: './full-screen-button.scss'
})
export class FullScreenButton {
  public readonly isFullscreen = signal(false);


  fullScreenClick(): void {
    if (this.isFullscreen()) {
      (document as Document).exitFullscreen()
    } else {
      (document.documentElement as HTMLElement).requestFullscreen()
    }
    this.isFullscreen.update(u => !u);
  }

}
